import { onBeforeUnmount } from "vue";

type TargetElem = Document | HTMLElement | SVGSVGElement;

interface Listener {
  elem: TargetElem;
  type: string;
  listener: (this: TargetElem, ev: unknown) => unknown;
  options?: boolean | AddEventListenerOptions;
}

export function useNativeEvents() {
  const listeners = new Array<Listener>();

  onBeforeUnmount(() => {
    removeEventListeners();
  });

  function addEventListener<K extends keyof DocumentEventMap>(
    elem: Document,
    type: K,
    listener: (this: Document, ev: DocumentEventMap[K]) => unknown,
    options?: boolean | AddEventListenerOptions,
  ): void;
  function addEventListener<K extends keyof HTMLElementEventMap>(
    elem: HTMLElement | null,
    type: K,
    listener: (this: HTMLElement, ev: HTMLElementEventMap[K]) => unknown,
    options?: boolean | AddEventListenerOptions,
  ): void;
  function addEventListener<K extends keyof SVGSVGElementEventMap>(
    elem: SVGSVGElement | null,
    type: K,
    listener: (this: SVGSVGElement, ev: SVGSVGElementEventMap[K]) => unknown,
    options?: boolean | AddEventListenerOptions,
  ): void;
  function addEventListener(
    elem: TargetElem | null,
    type: string,
    listener: (this: TargetElem, ev: unknown) => unknown,
    options?: boolean | AddEventListenerOptions,
  ) {
    if (elem) {
      listeners.push({ elem, type, listener, options });
      elem.addEventListener(type, listener, options);
    }
  }

  function removeEventListeners() {
    for (const listener of listeners) {
      listener.elem.removeEventListener(listener.type, listener.listener, listener.options);
    }
    listeners.length = 0;
  }

  return { addEventListener, removeEventListeners };
}
